import { t } from "localizify";

export default function setTitle(title) {
  if (!document) {
    return;
  }

  document.title = t("app.page_title", { title });
}
